import { render, staticRenderFns } from "./indexzong.vue?vue&type=template&id=4da4a12c&scoped=true&"
import script from "./indexzong.vue?vue&type=script&lang=js&"
export * from "./indexzong.vue?vue&type=script&lang=js&"
import style0 from "./indexzong.vue?vue&type=style&index=0&id=4da4a12c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da4a12c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da4a12c')) {
      api.createRecord('4da4a12c', component.options)
    } else {
      api.reload('4da4a12c', component.options)
    }
    module.hot.accept("./indexzong.vue?vue&type=template&id=4da4a12c&scoped=true&", function () {
      api.rerender('4da4a12c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/indexzong.vue"
export default component.exports